import classNames from 'classnames'
import { InputHTMLAttributes, useState } from 'react'
import styles from './Input.module.scss'
import { Label } from '../Label/Label'

type VanillaProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange'>

export interface InputProps extends VanillaProps {
    label?: string
    errors?: string[] | readonly string[]
    tooltip?: string
    onChange: (value: string) => void
}

export const Input = ({
    errors = [],
    label,
    id,
    onChange,
    ...otherProps
}: InputProps) => {
    const [touched, setTouched] = useState(false)
    const isValid = !errors.length
    const [firstError] = errors
    const showErrors = !isValid && touched && firstError

    return (
        <div
            className={classNames(styles.field, {
                [styles.invalid]: showErrors,
            })}
        >
            {label && (
                <div className={styles.inputContainer}>
                    <Label for={id}>{label}</Label>
                </div>
            )}
            <div className={styles.inputContainer}>
                <input
                    {...otherProps}
                    id={id}
                    className={styles.input}
                    onChange={(e) => onChange(e.target.value)}
                    onBlur={() => setTouched(true)}
                />
            </div>
            {showErrors && firstError && (
                <div className={styles.errorContainer}>{firstError}</div>
            )}
        </div>
    )
}
